export default __webpack_public_path__ + "static/media/imgCamDoctor1.ae4d2de4.png";